import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import PreviewPortal from './pages/PreviewPortal';
import './App.css';

const getPreviewPortalRoute = () => {
  const pathname = window.location.pathname.replace(/\/+$/, '') || '/';

  if (pathname === '/preview-admin') {
    return {
      mode: 'admin',
      previewId: '',
    };
  }

  const previewMatch = pathname.match(
    /^\/(?:preview|p)\/([^/]+)$/i
  );

  if (previewMatch) {
    return {
      mode: 'preview',
      previewId: decodeURIComponent(previewMatch[1]),
    };
  }

  return null;
};

function App() {
  const previewPortalRoute = getPreviewPortalRoute();

  if (previewPortalRoute) {
    return (
      <PreviewPortal
        mode={previewPortalRoute.mode}
        previewId={previewPortalRoute.previewId}
      />
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App;